import { Box, Flex, Progress, Text } from '@mantine/core';

export default function UsageCard(props: { label: string; value: number; total: number }) {
  const { label, value, total } = props;
  const percentage = total > 0 ? (value / total) * 100 : 0;
  const renderColor = () => {
    if (percentage > 70) return 'red';
    if (percentage > 30) return 'blue';
    return 'green';
  };

  return (
    <Box
      style={{
        border: '1px solid var(--mantine-color-gray-3)',
        borderRadius: 'var(--mantine-radius-sm)',
      }}
      py={8}
      px={12}
    >
      <Flex columnGap="sm" rowGap={4} align="center" wrap="wrap">
        <Text fw={500} size="sm">
          {label}
        </Text>
        <Progress value={percentage} size="md" w={100} color={renderColor()} />
        <Text size="sm">
          {Math.round(percentage)}%
          <Text component="span" c="dimmed" size="xs" ml={4}>
            ({value} / {total})
          </Text>
        </Text>
      </Flex>
    </Box>
  );
}
